export default __webpack_public_path__ + "static/media/IconPeriod.d4247868.svg";